// extracted by mini-css-extract-plugin
module.exports = {"reservesContainer":"styles-module__reservesContainer___1dhme","overriddenTable":"styles-module__overriddenTable___3LTkT"};